import Button from '@/shared/ui/button';

interface Props {
    loginToAccount: () => void;
}

const ResetSuccess = ({ loginToAccount }: Props) => {
    return (
        <div className="flex flex-col gap-7 py-2.5" data-testid="button-reset-success-container">
            <h2 data-testid="button-reset-success-title" className="text-2xl sm:text-4xl font-normal text-center lg:leading-[49px] font-agrandir">
                Your password has been reset successfully!
            </h2>
            <Button
                sx={{ width: '100%' }}
                showEndIcon
                onClick={loginToAccount}
                fontClassName="text-base"
                testId="button-reset-login"
            >
                Login to Account
            </Button>
        </div>
    );
};

export default ResetSuccess;
